import { Coordinates } from '../coordinates.model';
import { Nommable } from '../nommable.model';
import { Pointeau } from './pointeau.model';
import { ISite } from './site.interface';
import { Zone } from './zone.model';

export class Site extends Nommable implements ISite {
  constructor(
    public readonly id: string,
    public readonly libelle: string,
    public readonly adresse: string,
    public readonly nonReference: boolean,
    public readonly location?: Coordinates,
    public readonly pointeaux?: Pointeau[],
    public readonly zone?: Zone
  ) {
    super(id, libelle);
  }

  public static hydrate(site: ISite): ISite {
    return new Site(
      site.id,
      site.libelle,
      site.adresse,
      site.nonReference,
      site.location ? Coordinates.hydrate(site.location) : undefined,
      site.pointeaux ? site.pointeaux.map(Pointeau.hydrate) : [],
      site.zone ? Zone.hydrate(site.zone) : undefined
    );
  }

  public clone(): ISite {
    return Site.hydrate(this);
  }
}
